module.exports = __webpack_public_path__ + "img/icon-user.200995d3.jpg";